import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ToolTipDirective } from './toolTipDirective';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ToolTipDirective,
  ],
  exports: [
        ToolTipDirective,
  ]
})
export class TooltipModule {
}
